// removed by extract-text-webpack-plugin
module.exports = {"root":"_1hyi3","banner":"_39SAG","nextButton":"_CQXjq","previousButton":"_2V3bV","swiper-preloader-spin":"_2kvik"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/BundleBanners/BundleBanners.scss
// module id = 1321
// module chunks = 3